import { Link } from 'react-router-dom';
import { recentActivity } from '@/mocks/dashboard';

const typeStyles: Record<string, { icon: string; classes: string; border: string }> = {
  earn: {
    icon: 'ri-add-line',
    classes: 'bg-emerald-500/10 text-emerald-700 shadow-xs shadow-emerald-500/20',
    border: 'border-emerald-500/20',
  },
  redeem: {
    icon: 'ri-gift-2-line',
    classes: 'bg-rose-500/10 text-rose-700 shadow-xs shadow-rose-500/20',
    border: 'border-rose-500/20',
  },
  adjust: {
    icon: 'ri-equalizer-line',
    classes: 'bg-blue-500/10 text-blue-700 shadow-xs shadow-blue-500/20',
    border: 'border-blue-500/20',
  },
};

export default function ActivityList() {
  return (
    <div className="bg-white border border-background-200 rounded-2xl p-5 md:p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
              Recent activity
            </h3>
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
          </div>
          <p className="text-xs text-foreground-500 mt-0.5">Real-time ledger events</p>
        </div>
        <Link
          to="/dashboard/transactions"
          className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 transition-colors py-1 px-2.5 rounded-lg hover:bg-primary-500/10"
        >
          View all
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <ul className="flex flex-col gap-2">
        {recentActivity.map((item, index) => {
          const style = typeStyles[item.type] ?? typeStyles.adjust;
          const positive = item.points > 0;
          return (
            <li
              key={item.id}
              className="flex items-center gap-3 p-2.5 rounded-xl transition-all duration-200 hover:bg-background-100/80 hover:translate-x-1 cursor-default"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <span
                className={`w-9 h-9 shrink-0 flex items-center justify-center rounded-xl border ${style.border} ${style.classes} transition-transform duration-200 group-hover:scale-105`}
              >
                <i className={`${style.icon} text-base`}></i>
              </span>

              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-foreground-950 truncate">
                  {item.member}{' '}
                  <span className="font-normal text-xs text-foreground-500">· {item.action}</span>
                </p>
                <p className="text-xs text-foreground-500 truncate">{item.detail}</p>
              </div>

              <div className="text-right shrink-0">
                <p
                  className={`font-heading text-sm font-extrabold ${
                    positive ? 'text-emerald-700' : 'text-rose-700'
                  }`}
                >
                  {positive ? '+' : ''}
                  {item.points.toLocaleString()}
                </p>
                <p className="text-[11px] text-foreground-400 font-medium whitespace-nowrap">
                  {item.time}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
